module.exports = __webpack_public_path__ + "static/media/ticTacToeImg5.5aab3117.png";